import { useMemo } from 'react';

import type { PreviewChartProps } from '@/features/DataHub/constants/charts';

import PreviewChartLayout from './PreviewChartLayout';
import usePreviewOptions from './usePreviewOptions';
import useSpotChartData from './useSpotChartData';

const PreviewSpotChart = ({ symbols, showLegend }: PreviewChartProps) => {
  const { loading, error, chartSeries, baseOptions, xAxisMin, xAxisMax } =
    useSpotChartData(symbols);
  const previewOptions = usePreviewOptions(baseOptions);

  const options = useMemo(() => {
    if (!previewOptions) return undefined;

    return {
      ...previewOptions,
      legend: { ...previewOptions.legend, enabled: showLegend },
      xAxis: {
        ...previewOptions.xAxis,
        min: xAxisMin,
        max: xAxisMax
      }
    };
  }, [previewOptions, showLegend, xAxisMin, xAxisMax]);

  return (
    <PreviewChartLayout
      chartSeries={chartSeries}
      chartType='spot'
      error={error}
      loading={loading}
      options={options}
    />
  );
};

export default PreviewSpotChart;
